import controller from './kform-tab-wf.controller';
import template from './kform-tab-wf.html';

export default {
	controller,
	template,
	bindings: {
		form:       '<',
		submission: '<',
		kid:        '<',
	},
	require:  {
		kform: '^^kform',
	},
};
